import gql from 'graphql-tag'

export default gql`
  mutation addEnterpriseCustomer($company: String!, $startDate: String!, $expirationDate: String!, $quantity: Int!, $payerUserId: String!) {
    addEnterpriseCustomer(company: $company, startDate: $startDate, expirationDate: $expirationDate, quantity: $quantity, payerUserId: $payerUserId) {
      success
      message
    }
  }
`
